import { styled, Box, IconButton, Paper } from '@mui/material';
import color from 'src/theme/color';

export const POPUP_WIDTH = 1000;
export const POPUP_HEIGHT = 800;
export const CONTENT_HEIGHT = 500;

export const StyledDialogPaper = styled(Paper)({
    backgroundColor: color.blackLight2,
    color: color.white,
    borderRadius: '8px',
    width: POPUP_WIDTH,
    height: POPUP_HEIGHT,
    maxHeight: POPUP_HEIGHT,
    display: 'flex',
    flexDirection: 'column'
});

export const HeaderBox = styled(Box)({
    padding: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});

export const TitleTypographyStyles = {
    color: color.white
};

export const CounterTypographyStyles = {
    color: color.white,
    flexGrow: 1,
    textAlign: 'center'
};

export const CloseIconButtonStyles = {
    color: color.white
};

export const FileInfoBox = styled(Box)({
    paddingLeft: '16px',
    paddingRight: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});

export const FileNameTypographyStyles = {
    color: color.white
};

export const DownloadIconButtonStyles = {
    marginLeft: 'auto'
};

export const ContentBox = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    marginTop: '32px',
    marginBottom: '32px',
    position: 'relative',
    backgroundColor: color.blackLight2,
    height: CONTENT_HEIGHT,
    flexGrow: 1
});

export const ImageContainer = styled(Box)({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden'
});

export const StyledImage = styled('img')({
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain'
});

export const VideoContainer = styled(Box)({
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});

export const VideoWrapper = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 'calc(100% - 70px)',
    position: 'relative',
    overflow: 'hidden'
});

export const StyledVideo = styled('video')({
    width: '100%',
    height: '100%',
    objectFit: 'contain'
});

export const PlayButtonOverlay = styled(IconButton)({
    position: 'absolute',
    backgroundColor: color.lightningYellow,
    '&:hover': {
        backgroundColor: color.yellow60
    },
    width: '64px',
    height: '64px'
});

export const PlayIconStyles = {
    fontSize: 36,
    color: color.blackLight2
};

export const VideoControlsBox = styled(Box)({
    width: '100%',
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingBottom: '16px',
    paddingTop: '8px',
    backgroundColor: color.blackLight2,
    height: '70px',
    boxSizing: 'border-box'
});

export const SliderStyles = {
    color: color.lightningYellow,
    height: 4,
    '& .MuiSlider-thumb': {
        display: 'none'
    },
    '& .MuiSlider-rail': {
        opacity: 0.3,
        backgroundColor: color.darkGray
    },
    '& .MuiSlider-track': {
        border: 'none'
    }
};

export const ControlsContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '8px'
});

export const PlaybackControls = styled(Box)({
    display: 'flex',
    alignItems: 'center'
});

export const ControlIconButtonStyles = {
    color: color.white
};

export const ControlIconButtonWithMarginStyles = {
    color: color.white,
    marginLeft: '8px',
    marginRight: '8px'
};

export const TimeTypographyStyles = {
    color: color.hitGray
};

export const NextButtonContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '32px'
});

export const NextButton = styled(IconButton)({
    backgroundColor: color.yellow,
    color: color.white,
    '&:hover': {
        backgroundColor: color.yellow80
    },
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingTop: '12px',
    paddingBottom: '12px',
    borderRadius: '40px'
});

export const NextButtonTextStyles = {
    paddingLeft: '16px',
    paddingRight: '16px'
};

export const NoPreviewContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    color: color.white
});

export const NoPreviewTextStyles = {
    color: color.hitGray
};
